import { Box, Grid2, Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import androidAppQRCode from '../../../assets/androidGooglePlayQRCode.png';
import appAndroid from '../../../assets/GooglePlayStore.svg';
import appIos from '../../../assets/iOSAppStore.svg';
import iosAppQRCode from '../../../assets/iOSAppStoreQRCode.png';
import my2nAppIcon from '../../../assets/my2nAppIcon.svg';
import { MOBILE_APP_LINKS } from '../../../config/consts';
import messages from './messages';

const styles = {
  downloadAppContainer: {
    display: 'flex',
    flexDirection: { sm: 'row', xs: 'column' },
    justifyContent: 'space-between',
    mb: { sm: '64px', xs: 3 },
    px: '24px',
  },
  my2nAppIcon: {
    '& img': {
      height: 115,
      width: 115,
    },
    mb: { sm: 5, xs: 4 },
  },
  qrcode: {
    display: { sm: 'block', xs: 'none' },
    height: '50px',
    width: '150px',
  },
  root: {
    backgroundColor: 'landingPage.paper',
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.5,
    margin: { sm: '64px auto', xs: '64px 45px 32px 45px' },
    maxWidth: '600px',
    textAlign: 'center',
  },
  storeImg: {
    display: { sm: 'block', xs: 'flex' },
    height: '50px',
    justifyContent: 'center',
    margin: '0 auto',
    mb: { sm: 2.5 },
    width: '150px',
  },
};

export function AppDownloadMainInfo() {
  const { APP_STORE_LINK, GOOGLE_PLAY_LINK } = MOBILE_APP_LINKS;

  return (
    <Grid2 sx={styles.root}>
      <Box sx={styles.my2nAppIcon}>
        <img alt="My2N App Icon" src={my2nAppIcon} />
      </Box>
      <Box sx={{ mb: { sm: 4, xs: 3 } }}>
        <Typography variant="h4" fontWeight="medium">
          <FormattedMessage {...messages.PublicMy2nAppDownloadTitle} />
        </Typography>
      </Box>
      <Box sx={{ mb: { sm: 6, xs: 5 } }}>
        <Typography variant="body1">
          <FormattedMessage {...messages.PublicMy2nAppDownloadText} />
        </Typography>
      </Box>
      <Grid2 sx={styles.downloadAppContainer}>
        <Grid2>
          <Link
            href={APP_STORE_LINK}
            rel="noopener noreferrer"
            target="_blank"
            sx={{ ...styles.storeImg, mb: { sm: 2.5, xs: 3 } }}
          >
            <img alt="Get it on Apple store" src={appIos} />
          </Link>
          <Box sx={styles.qrcode}>
            <img alt="Apple Store QR code" src={iosAppQRCode} />
          </Box>
        </Grid2>
        <Grid2>
          <Link target="_blank" href={GOOGLE_PLAY_LINK} rel="noopener noreferrer" sx={styles.storeImg}>
            <img alt="Get it on Google Play" src={appAndroid} />
          </Link>
          <Box sx={styles.qrcode}>
            <img alt="Google Play QR code" src={androidAppQRCode} />
          </Box>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
